import {
  RadioGroupButton,
  type RadioGroupButtonConfig,
} from '@carboncopyco/ui';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage, FormField } from './FormField';

type ResponseType = 'static' | 'dynamic' | 'custom';

const fieldName = 'responseType';

export interface ResponseTypeFieldProps {
  disabled?: boolean;
  disabledField?: ResponseType;
}

export const ResponseTypeField = ({
  disabled,
  disabledField,
}: ResponseTypeFieldProps) => {
  const { editorDataRulesModifierFromScratch } = useFlags();

  const {
    register,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();
  const responseType = watch(fieldName);

  const buttonsConfig: RadioGroupButtonConfig<ResponseType>[] = [
    {
      id: 'static',
      name: 'static',
      label: 'Static response',
    },
    {
      id: 'dynamic',
      name: 'dynamic',
      label: 'Dynamic response',
    },
    ...(editorDataRulesModifierFromScratch
      ? [
          {
            id: 'custom',
            name: 'custom',
            label: 'Build from scratch',
          } as RadioGroupButtonConfig<ResponseType>,
        ]
      : []),
  ];

  useEffect(() => {
    register(fieldName);
  }, []);

  return (
    <FormField name={fieldName}>
      <div className="self-start">
        <RadioGroupButton<ResponseType>
          buttonsConfig={buttonsConfig.map((config) => ({
            ...config,
            disabled: disabled || config.id === disabledField,
          }))}
          onClick={(type) => {
            setValue(fieldName, type);
          }}
          selected={responseType}
        />
      </div>
      <ErrorMessage errors={errors} />
    </FormField>
  );
};
